import React from 'react'
import { revenueCodesAndNames, sumOfArray, expenditureCodesAndNames, formatToZMW } from '../../../../helpers'
import { useOutletContext } from 'react-router-dom'

const Bcomp2 = ({currentYearData, startDate}) => {

    const {allData, setAllData} = useOutletContext();
    const currentYear = startDate ? new Date(startDate).getFullYear() : new Date().getFullYear();
  return (
    <div className='my-5'>
           <hr className="border-t-2 border-slate-200 py-5" />
        <h1 className='text-2xl font-bold text-slate-800'>THE STATEMENT OF COMPARISON OF BUDGET AND ACTUAL AMOUNTS FOR THE YEAR
        ENDED 31ST DECEMBER {currentYear}</h1>

        <table className="w-full table-auto border-collapse shadow-sm rounded-lg overflow-hidden">
            <thead className="bg-blue-950 text-white">
                <tr>
                    <th className="text-left px-4 py-3 w-2/5"></th>
                    <th className="text-center px-4 py-3 w-1/6">Budget</th>
                    <th className="text-center px-4 py-3 w-1/6">Actual</th>
                    <th className="text-center px-4 py-3 w-1/6">Performance (%)</th>
                    <th className="text-center px-4 py-3 w-1/6">Variance</th>
                    <th className="text-center px-4 py-3 w-1/6">Variance (%)</th>
                </tr>
            </thead>

            <tbody className="bg-white">
                {/* Receipts Section */}
                <tr className="bg-gray-100">
                    <td colSpan={6} className="px-4 py-2 font-semibold text-slate-700">Receipts</td>
                </tr>
                {revenueCodesAndNames.map((code) => {
                    const budgetAmount = sumOfArray(
                        allData.budget
                            ?.filter(a => a?.coa && String(a.coa).substring(0, 3) === code.id)
                            ?.map(a => parseFloat(a?.price) || 0) || []
                    ) || 0;
                    
                    // Skip rows with zero budget
                    if (budgetAmount === 0) return null;
                    
                    const actualAmount = sumOfArray(
                        currentYearData
                            ?.filter(a => a?.coa && String(a.coa).substring(0, 3) === code.id && a.type === 'income')
                            ?.map(a => parseFloat(a?.amount) || 0) || []
                    ) || 0;
                    
                    const performance = budgetAmount > 0 ? (actualAmount / budgetAmount) * 100 : 0;
                    const variance = actualAmount - budgetAmount;
                    const variancePercent = budgetAmount > 0 ? (variance / budgetAmount) * 100 : 0;
                    
                    return (
                        <tr key={code.id} className="odd:bg-gray-50">
                            <td className="px-4 py-2 text-slate-800">{code.name}</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{formatToZMW(budgetAmount)}</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{formatToZMW(actualAmount)}</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{performance.toFixed(1)}%</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{formatToZMW(variance)}</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{variancePercent.toFixed(1)}%</td>
                        </tr>
                    );
                })}
                
                {/* Receipts Totals */}
                <tr className="bg-gray-100 font-semibold border-t border-gray-200">
                    <td className="px-4 py-3 text-slate-800">Total Receipts</td>
                    <td className="px-4 py-3 text-center">{formatToZMW(sumOfArray(
                        allData.budget
                            ?.filter(a => revenueCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)))
                            ?.map(a => parseFloat(a?.price) || 0) || []
                    ) || 0)}</td>
                    <td className="px-4 py-3 text-center">{formatToZMW(sumOfArray(
                        currentYearData
                            ?.filter(a => revenueCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'income')
                            ?.map(a => parseFloat(a?.amount) || 0) || []
                    ) || 0)}</td>
                    <td className="px-4 py-3 text-center">{(() => {
                        const totalReceiptsBudget = sumOfArray(
                            allData.budget
                                ?.filter(a => revenueCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)))
                                ?.map(a => parseFloat(a?.price) || 0) || []
                        ) || 0;
                        const totalReceiptsActual = sumOfArray(
                            currentYearData
                                ?.filter(a => revenueCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'income')
                                ?.map(a => parseFloat(a?.amount) || 0) || []
                        ) || 0;
                        return totalReceiptsBudget > 0 ? ((totalReceiptsActual / totalReceiptsBudget) * 100).toFixed(1) + '%' : '-';
                    })()}</td>
                    <td className="px-4 py-3 text-center">{(() => {
                        const totalReceiptsBudget = sumOfArray(
                            allData.budget
                                ?.filter(a => revenueCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)))
                                ?.map(a => parseFloat(a?.price) || 0) || []
                        ) || 0;
                        const totalReceiptsActual = sumOfArray(
                            currentYearData
                                ?.filter(a => revenueCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'income')
                                ?.map(a => parseFloat(a?.amount) || 0) || []
                        ) || 0;
                        return formatToZMW(totalReceiptsActual - totalReceiptsBudget);
                    })()}</td>
                    <td className="px-4 py-3 text-center">{(() => {
                        const totalReceiptsBudget = sumOfArray(
                            allData.budget
                                ?.filter(a => revenueCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)))
                                ?.map(a => parseFloat(a?.price) || 0) || []
                        ) || 0;
                        const totalReceiptsActual = sumOfArray(
                            currentYearData
                                ?.filter(a => revenueCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'income')
                                ?.map(a => parseFloat(a?.amount) || 0) || []
                        ) || 0;
                        return totalReceiptsBudget > 0 ? (((totalReceiptsActual - totalReceiptsBudget) / totalReceiptsBudget) * 100).toFixed(1) + '%' : '-';
                    })()}</td>
                </tr>
                
                {/* Payments Section */}
                <tr className="bg-gray-100">
                    <td colSpan={6} className="px-4 py-2 font-semibold text-slate-700">Payments</td>
                </tr>
                {expenditureCodesAndNames.map((code) => {
                    const budgetAmount = sumOfArray(
                        allData.budget
                            ?.filter(a => a?.coa && String(a.coa).substring(0, 3) === code.id)
                            ?.map(a => parseFloat(a?.price) || 0) || []
                    ) || 0;
                    
                    // Skip rows with zero budget
                    if (budgetAmount === 0) return null;
                    
                    const actualAmount = sumOfArray(
                        currentYearData
                            ?.filter(a => a?.coa && String(a.coa).substring(0, 3) === code.id && a.type === 'expense')
                            ?.map(a => parseFloat(a?.amount) || 0) || []
                    ) || 0;
                    
                    const performance = budgetAmount > 0 ? (actualAmount / budgetAmount) * 100 : 0;
                    const variance = actualAmount - budgetAmount;
                    const variancePercent = budgetAmount > 0 ? (variance / budgetAmount) * 100 : 0;
                    
                    return (
                        <tr key={code.id} className="odd:bg-gray-50">
                            <td className="px-4 py-2 text-slate-800">{code.name}</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{formatToZMW(budgetAmount)}</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{formatToZMW(actualAmount)}</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{performance.toFixed(1)}%</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{formatToZMW(variance)}</td>
                            <td className="px-4 py-2 text-center font-medium text-slate-800">{variancePercent.toFixed(1)}%</td>
                        </tr>
                    );
                })}
                
                {/* Payments Totals */}
                <tr className="bg-gray-100 font-semibold border-t border-gray-200">
                    <td className="px-4 py-3 text-slate-800">Total Payments</td>
                    <td className="px-4 py-3 text-center">{formatToZMW(sumOfArray(
                        allData.budget
                            ?.filter(a => expenditureCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)))
                            ?.map(a => parseFloat(a?.price) || 0) || []
                    ) || 0)}</td>
                    <td className="px-4 py-3 text-center">{formatToZMW(sumOfArray(
                        currentYearData
                            ?.filter(a => expenditureCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'expense')
                            ?.map(a => parseFloat(a?.amount) || 0) || []
                    ) || 0)}</td>
                    <td className="px-4 py-3 text-center">{(() => {
                        const totalPaymentsBudget = sumOfArray(
                            allData.budget
                                ?.filter(a => expenditureCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)))
                                ?.map(a => parseFloat(a?.price) || 0) || []
                        ) || 0;
                        const totalPaymentsActual = sumOfArray(
                            currentYearData
                                ?.filter(a => expenditureCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'expense')
                                ?.map(a => parseFloat(a?.amount) || 0) || []
                        ) || 0;
                        return totalPaymentsBudget > 0 ? ((totalPaymentsActual / totalPaymentsBudget) * 100).toFixed(1) + '%' : '-';
                    })()}</td>
                    <td className="px-4 py-3 text-center">{(() => {
                        const totalPaymentsBudget = sumOfArray(
                            allData.budget
                                ?.filter(a => expenditureCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)))
                                ?.map(a => parseFloat(a?.price) || 0) || []
                        ) || 0;
                        const totalPaymentsActual = sumOfArray(
                            currentYearData
                                ?.filter(a => expenditureCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'expense')
                                ?.map(a => parseFloat(a?.amount) || 0) || []
                        ) || 0;
                        return formatToZMW(totalPaymentsActual - totalPaymentsBudget);
                    })()}</td>
                    <td className="px-4 py-3 text-center">{(() => {
                        const totalPaymentsBudget = sumOfArray(
                            allData.budget
                                ?.filter(a => expenditureCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)))
                                ?.map(a => parseFloat(a?.price) || 0) || []
                        ) || 0;
                        const totalPaymentsActual = sumOfArray(
                            currentYearData
                                ?.filter(a => expenditureCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'expense')
                                ?.map(a => parseFloat(a?.amount) || 0) || []
                        ) || 0;
                        return totalPaymentsBudget > 0 ? (((totalPaymentsActual - totalPaymentsBudget) / totalPaymentsBudget) * 100).toFixed(1) + '%' : '-';
                    })()}</td>
                </tr>
                
                {/* Increase/(Decrease) in Cash */}
                <tr className="bg-blue-50 font-semibold border-t-2 border-blue-200">
                    <td className="px-4 py-3 text-slate-800">Increase/(Decrease) in Cash</td>
                    <td className="px-4 py-3 text-center">-</td>
                    <td className="px-4 py-3 text-center">{(() => {
                        const totalReceiptsActual = sumOfArray(
                            currentYearData
                                ?.filter(a => revenueCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'income')
                                ?.map(a => parseFloat(a?.amount) || 0) || []
                        ) || 0;
                        const totalPaymentsActual = sumOfArray(
                            currentYearData
                                ?.filter(a => expenditureCodesAndNames.some(c => c.id === String(a?.coa || '').substring(0, 3)) && a.type === 'expense')
                                ?.map(a => parseFloat(a?.amount) || 0) || []
                        ) || 0;
                        return formatToZMW(totalReceiptsActual - totalPaymentsActual);
                    })()}</td>
                    <td className="px-4 py-3 text-center">-</td>
                    <td className="px-4 py-3 text-center">-</td>
                    <td className="px-4 py-3 text-center">-</td>
                </tr>
            </tbody>
        </table>

        <p className='text-sm text-slate-700'>The composition of budget adjustments and explanations of major variances are provided in note .</p>
    </div>
  )
}

export default Bcomp2